import { Box, Typography } from '@mui/material'
import FormattedAgentText from '../FormattedAgentText'
import StreamingText from '../StreamingText'

const VARIANT_SX = {
  default: {
    fontSize: 'var(--app-agent-result-font-size, 13px)',
    fontWeight: 'var(--app-agent-result-font-weight)',
    color: 'var(--app-text-primary)',
  },
  muted: {
    fontSize: 'var(--app-agent-result-font-size, 13px)',
    fontWeight: 400,
    color: 'text.secondary',
  },
  emphasis: {
    fontSize: 'var(--app-agent-result-font-size, 13px)',
    fontWeight: 'var(--app-agent-result-font-weight-medium)',
    color: 'var(--app-text-primary)',
  },
}

const baseSx = (variant) => ({
  fontFamily: 'var(--app-font-sans)',
  lineHeight: 'var(--app-agent-result-line-height, 1.2)',
  whiteSpace: 'pre-wrap',
  m: 0,
  ...VARIANT_SX[variant] ?? VARIANT_SX.default,
})

/**
 * @param {{ children: React.ReactNode, variant?: 'default' | 'muted' | 'emphasis', streaming?: boolean }} props
 */
const Markdown = ({ children, variant = 'default', streaming = false }) => {
  const content = typeof children === 'string' ? children : String(children ?? '')

  if (streaming) {
    return (
      <Box sx={baseSx(variant)} aria-busy="true">
        <StreamingText text={content} showCaret formatted streaming />
      </Box>
    )
  }

  if (!content.trim()) return null

  return (
    <Typography component="p" variant="body2" sx={baseSx(variant)}>
      <FormattedAgentText text={content} />
    </Typography>
  )
}

export default Markdown
